import { Component } from '@angular/core';
import { IntercomProvider } from '../../providers/intercom/intercom';

@Component({
  selector: 'menu-toggle',
  templateUrl: 'menu-toggle.html'
})
export class MenuToggleComponent {

  constructor(public intercom: IntercomProvider) {
  }

}



// WEBPACK FOOTER //
// ./src/components/menu-toggle/menu-toggle.ts